import {
  Edit,
  Filter,
  PlusCircle,
  RotateCcw,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Brand from "../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationDataTable from "../../core/pagination/PaginationDataTable";
import { Download } from "react-feather";
import Axios from "axios";
import {
  API_BASE_URL,
  // GET_VSTORE_PROD,
  GET_USER_STORES,
  IMAGE_URL_IBIZ,
  GET_USER_PERMISSIONS,
  GET_DDL,
  GET_BARCODE_TYPE,
} from "../../Config";
// import { set_product_list } from "../../core/redux/action";
import qs from "qs";
import useOnlineStatus from "../../userOnlineStatus";
import OnlineImg from "./online.jpg";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getUserPermissions } from "../../UserPermissions";
import ProductExcels from "./productexcels";
import JsBarcode from "jsbarcode";
import QRCode from "qrcode";
import SpinLoader from "../loader/SpinLoader";

const ProductList = () => {
  const isOnline = useOnlineStatus();
  // const location = useLocation();
  const navigate = useNavigate();
  // const dispatch = useDispatch();

  // ==================== ALL STATES ====================
  const [userDataSession, setUserDataSession] = useState([]);
  const [storesData, setStoresData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [productsDataDD, setProductsDataDDL] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  // const [isForSale, setIsForSale] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [barcodeInput, setBarcodeInput] = useState("");

  const [loading, setLoading] = useState(false);
  const [isStoreLoading, setIsStoreLoading] = useState(false);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [isProductLoading, setIsProductLoading] = useState(false);

  const [displayCuStock, setDisplayCuStock] = useState(true);
  const [displayStoreStock, setDisplayStoreStock] = useState(false);
  const [displayStorePrice, setDisplayStorePrice] = useState(false);
  const [displayAvgPrice, setDisplayAvgPrice] = useState(true);

  const [printBarcodeDataUI, setPrintBarcodeDataUI] = useState([]);
  const [permissionsLoaded, setPermissionsLoaded] = useState(false);
  // const [getStoreProducts, setGetStoreProducts] = useState([]);
  const [parsedHtmlPreview, setParsedHtmlPreview] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [totalRecords, setTotalRecords] = useState(0);
  const [products, setProducts] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageName, setSelectedImageName] = useState(null);
  const [printBarcodeData, setPrintBarcodeData] = useState(null);
  const [printQRcodeData, setPrintQRcodeData] = useState(null);

  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prev) => {
      const newState = !prev;

      if (!newState) {
        // When closing filter → clear dropdowns
        setSelectedCategory(null);
        setSelectedStore(null);
        setSelectedProduct(null);
        setBarcodeInput("");
        setSearchQuery("");
      }

      return newState;
    });
  };
  const barcodeRef = useRef();
  const qrCodeRef = useRef();
  const MySwal = withReactContent(Swal);
  const route = all_routes;

  const fetchPaginatedProducts = async (
    page = 1,
    size = 30,
    isForExport = false,
  ) => {
    if (!userDataSession?.OrgId) return;

    if (!isForExport) setLoading(true);

    const payload = {
      OrgId: userDataSession.OrgId,
      UserId: userDataSession.UserId,
      ProductId: selectedProduct?.value || 0,
      CategoryId: selectedCategory?.value || 0,
      AllStores: selectedStore?.value ? String(selectedStore.value) : "0",
      PageNumber: page,
      PageSize: isForExport ? 9999 : size, // Large number to get all records
      IsForSale: 1,
      BarCode: barcodeInput.trim() || "0",
      SearchText: searchQuery.trim(),
    };

    try {
      const response = await Axios.post(
        `${API_BASE_URL}Product/GetStoreProductsPG`,
        payload,
      );

      if (response.data?.Status) {
        const result = response.data.ResultData || [];

        if (isForExport) {
          return result; // Return full data for export
        }

        setProducts(result);
        setTotalRecords(result[0]?.TotalRecords || 0);
        setCurrentPage(result[0]?.CurrentPage || page);
      } else {
        if (!isForExport) {
          setProducts([]);
          setTotalRecords(0);
        }
      }
    } catch (err) {
      console.error(err);
      if (!isForExport) {
        setProducts([]);
        setTotalRecords(0);
      }
    } finally {
      if (!isForExport) setLoading(false);
    }
  };

  // const fetchProductsForCurrentStore = (force = false) => {
  //   if (!userDataSession?.OrgId || !userDataSession?.UserId) return;

  //   const cacheKey = getCacheKey();

  //   if (!force) {
  //     const cached = sessionStorage.getItem(cacheKey);
  //     if (cached) {
  //       const parsed = JSON.parse(cached);
  //       setGetStoreProducts(parsed);
  //       dispatch(set_product_list(parsed));
  //       console.log("Cache key", cacheKey);
  //       return;
  //     }
  //   }

  //   setLoading(true);
  //   const requestData = {
  //     OrgId: userDataSession.OrgId,
  //     CategoryId: 0,
  //     BarCode: "0",
  //     IsActive: 1,
  //     ProductId: 0,
  //     StoreId: selectedStore?.value || 0,
  //     IsForSale: 1,
  //     UserId: userDataSession.UserId,
  //     Type: 0,
  //   };

  //   Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
  //     .then((response) => {
  //       if (response.data?.Status) {
  //         const products = response.data.ResultData || [];
  //         setGetStoreProducts(products);
  //         dispatch(set_product_list(products));
  //         // sessionStorage.setItem(cacheKey, JSON.stringify(products));
  //         console.log("Fetched & cached (Org+Store) →", cacheKey);
  //       } else {
  //         setGetStoreProducts([]);
  //         dispatch(set_product_list([]));
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Fetch error:", err);
  //       setGetStoreProducts([]);
  //       dispatch(set_product_list([]));
  //     })
  //     .finally(() => setLoading(false));
  // };

  // Your original useEffects (kept as-is)
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    const categoryData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_CATEGORY") || "[]",
    );

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      setCategoryData(categoryData);
    } else {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`,
      )
        .then((response) => setStoresData(response.data?.ResultData || []))
        .catch(console.error)
        .finally(setIsStoreLoading(false));

      Axios.get(
        `${API_BASE_URL}${GET_BARCODE_TYPE}?OrgId=${userDataSession.OrgId}`,
      ).then((response) => {
        if (response.data.Status)
          setPrintBarcodeDataUI(response.data.ResultData[0]);
      });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      fetchUserPermissions();
    }
  }, [userDataSession]);
  useEffect(() => {
    if (!userDataSession?.OrgId) {
      setProductsDataDDL([]);
      setIsProductLoading(false);
      return;
    }

    const storeId = selectedStore?.value || 0;
    const catId = selectedCategory?.value || 0;

    // No store selected → clear dropdown
    if (storeId === 0) {
      setProductsDataDDL([]);
      setIsProductLoading(false);
      return;
    }

    // Show loading right away
    setIsProductLoading(true);

    const fetchProducts = async () => {
      try {
        const params = {
          OrgId: userDataSession.OrgId,
          StoreId: storeId,
          CategoryId: catId, // ← Pass selected category here
          ProductId: 0,
        };

        console.log("Sending to ProductsDDL:", params);

        const response = await Axios.get(`${API_BASE_URL}Product/ProductsDDL`, {
          params,
        });

        let products = [];

        if (response.data?.ResultData) {
          products = response.data.ResultData;
          console.log(
            `API returned ${products.length} products (store=${storeId}, cat=${catId})`,
          );
        } else {
          console.warn("No ResultData → empty list");
        }

        setProductsDataDDL(products);
      } catch (error) {
        console.error("Products DDL fetch failed:", error);
        setProductsDataDDL([]);
      } finally {
        setIsProductLoading(false); // Always stop loading
      }
    };

    fetchProducts();
  }, [userDataSession?.OrgId, selectedStore?.value, selectedCategory?.value]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setIsCategoryLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_DDL}?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`,
      )
        .then((response) => {
          const allData = response.data.ResultData || [];
          const ddlNames = [
            "Supplier",
            "CATEGORY",
            "Subcategories",
            "Products",
            "variantypes",
            "TAX",
            "Stores",
            "BRAND",
            "Roles",
            "Staff",
            "Customers",
            "UNITS",
            "Cities",
          ];

          ddlNames.forEach((name) => {
            const filteredData = allData.filter(
              (item) => item.DDLName === name,
            );
            sessionStorage.setItem(
              `filteredDDLData_${name}`,
              JSON.stringify(filteredData),
            );
          });

          const updatedCategoryData = JSON.parse(
            sessionStorage.getItem("filteredDDLData_CATEGORY") || "[]",
          );
          setCategoryData(updatedCategoryData);
        })
        .finally(() => setIsCategoryLoading(false));
    }
  }, [userDataSession]);

  const fetchUserPermissions = () => {
    Axios.get(
      `${API_BASE_URL}${GET_USER_PERMISSIONS}?OrgId=${userDataSession.OrgId}&RoleId=${userDataSession.RoleId}&ModuleId=0`,
    )
      .then((response) => {
        sessionStorage.setItem(
          "UserPermissions",
          JSON.stringify(response.data.ResultData),
        );
        setPermissionsLoaded(true);
      })
      .catch(console.error);
  };

  const [permissions, setPermissions] = useState({
    isRead: "d-none",
    isWrite: "d-none",
    isDelete: "d-none",
    isExport: "d-none",
  });

  useEffect(() => {
    setPermissions(getUserPermissions("Products List"));
  }, [permissionsLoaded]);

  // Options
  const storeOptions = [
    { value: 0, label: "All" },
    ...storesData.map((store) => ({ value: store.StoreId, label: store.Name })),
  ];
  const categoryOptions = [
    { value: 0, label: "All" },
    ...categoryData.map((c) => ({ value: c.ItemId, label: c.ItemValue })),
  ];
  const productOptions = [
    { value: 0, label: "All" },
    ...productsDataDD.map((p) => ({ value: p.Id, label: p.ProductName })),
  ];

  // Trigger pagination on filter change
  useEffect(() => {
    if (userDataSession?.OrgId) {
      fetchPaginatedProducts(1, pageSize);
    }
  }, [userDataSession]);

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    setSelectedProduct(null); // New: Reset product selection on category change
    setIsProductLoading(true); // New: Start loading for Product dropdown
  };

  const handleStoreChange = (selectedOption) => {
    setSelectedStore(selectedOption);
    setSelectedProduct(null);
    setIsProductLoading(true);
  };

  const handleProductChange = (selectedOption) => {
    setSelectedProduct(selectedOption);
  };

  // const handleCheckboxChange = (event) => {
  //   setIsForSale(event.target.checked);
  // };

  const handleSearchClick = () => {
    const barcode =
      document.querySelector("#barcodeInput")?.value?.trim() || "0";
    setBarcodeInput(barcode);

    if (!selectedStore || selectedStore.value === 0) {
      setDisplayCuStock(true);
      setDisplayStoreStock(false);
      setDisplayAvgPrice(true);
      setDisplayStorePrice(false);
    } else {
      setDisplayCuStock(false);
      setDisplayStoreStock(true);
      setDisplayAvgPrice(false);
      setDisplayStorePrice(true);
    }

    fetchPaginatedProducts(1, pageSize);
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    fetchPaginatedProducts(page, size);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "ProductName",
      sorter: (a, b) => a.ProductName.length - b.ProductName.length,
      render: (text, record) => {
        const getFirstLetter = (str) => {
          const match = str.match(/[a-zA-Z]/);
          return match ? match[0].toUpperCase() : "N/A";
        };

        return (
          <div className="d-flex align-items-center">
            {record.ImagePath ? (
              <img
                src={`${IMAGE_URL_IBIZ}${record.ImagePath}`}
                alt=""
                style={{
                  width: "40px",
                  height: "40px",
                  marginRight: "10px",
                  borderRadius: "50%",
                }}
                onClick={() => handleImageClick(record)}
              />
            ) : (
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#FF9F43",
                  marginRight: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  fontSize: "18px",
                  color: "#fff",
                }}
              >
                {text ? getFirstLetter(text) : "N/A"}
              </div>
            )}
            <span>{text}</span>
          </div>
        );
      },
    },

    //   {
    //     title: "Logo",
    //     dataIndex: "ImagePath",
    //     render: (filepath) => (
    //         <div>
    //             <img className="rounded" src={`https://pcuploadfiles.azurewebsites.net/download?path=${filepath}`} alt="brand" style={{ width: '3.6rem' }} />
    //         </div>
    //     ),
    // },

    {
      title: "Category",
      dataIndex: "CategoryName",
      // sorter: (a, b) => a.CategoryName.length - b.CategoryName.length,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Barcode",
      dataIndex: "BarCode",
      // sorter: (a, b) => a.BarCode.length - b.BarCode.length,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "MRP",
      dataIndex: "MRP",
      // sorter: (a, b) => a.MRP.length - b.MRP.length,
      render: (record) => (record ? record : "0"),
    },
    ...(displayAvgPrice
      ? [
          {
            title: "Price",
            dataIndex: "AvgPrice",
            // sorter: (a, b) => a.AvgPrice.length - b.AvgPrice.length,
            render: (record) => (record ? record : "0"),
          },
        ]
      : []),
    ...(displayStorePrice
      ? [
          {
            title: "Price",
            dataIndex: "StorePrice",
            // sorter: (a, b) => a.StorePrice.length - b.StorePrice.length,
            render: (record) => (record ? record : "0"),
          },
        ]
      : []),
    ...(displayCuStock
      ? [
          {
            title: "Current Stock",
            dataIndex: "StockByUsers",
            render: (record) =>
              record ? parseFloat(record).toFixed(2) : "0.00",
          },
        ]
      : []),

    ...(displayStoreStock
      ? [
          {
            title: "Current Stock",
            dataIndex: "InStock",
            render: (record) =>
              record ? parseFloat(record).toFixed(2) : "0.00",
          },
        ]
      : []),

    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            {/* <Link
              className={`me-2 p-2 ${permissions.isWrite} d-flex align-item-center`}
              to={{
                pathname: route.editproduct,
                search: qs.stringify({ product: JSON.stringify(record.Id) }),
              }}
            > */}
            <Link
              className={`me-2 p-2 ${permissions.isWrite} d-flex align-item-center`}
              to={{
                pathname: route.editproduct,
                search: qs.stringify({ id: record.Id }),
              }}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link
              className="me-2 p-2 d-flex align-item-center"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightViewBarcode"
              aria-controls="offcanvasRightViewBarcode"
              onClick={() => handlePreviewBarcode(record)}
            >
              <i className="fa-solid fa-barcode"></i>
            </Link>
            <Link
              className="me-2 p-2 d-flex align-item-center"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightViewQRcode"
              aria-controls="offcanvasRightViewQRcode"
              onClick={() => handleGenerateQRCode(record)}
            >
              <i className="fa-solid fa-qrcode"></i>
            </Link>
            {/* <Link
              className={`confirm-text p-2 d-flex align-item-center ${permissions.isDelete}`}
              to="#"
              onClick={showConfirmationAlert}
            >
              <Trash2 className="feather-trash-2" />
            </Link> */}
            <Link
              className={`confirm-text p-2 d-flex align-item-center ${
                permissions.isDelete ? "" : "d-none"
              }`}
              // className="d-none"
              to="#"
              onClick={() => handleDeleteConfirmation(record)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </td>
      ),
    },
  ];

  const handleImageClick = (record) => {
    setSelectedImage(record.ImagePath);
    setSelectedImageName(record.ProductName);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  // ==================== BARCODE & QR LOGIC (YOUR ORIGINAL) ====================
  const handlePreviewBarcode = (item) => {
    console.log(item, "data assign at prievie btn click");
    setPrintBarcodeData(item);
    setTimeout(() => {
      generateBarcode(item);
    }, 0);
  };

  useEffect(() => {
    if (printBarcodeData) {
      generateBarcode(printBarcodeData);
    }
  }, [printBarcodeData]);

  const generateBarcode = (item) => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, item.BarCode, {
        format: "CODE128",
        lineColor: "#000",
        width: 2,
        height: 40,
        displayValue: true,
      });
    } else {
      console.error("barcodeRef.current is undefined");
    }
  };

  const handlePrintBarcode = (item) => {
    console.log(item);
    setPrintBarcodeData(item);
    console.log(item, "barcode printing data");
    console.log(printBarcodeDataUI?.HtmlString, "printBarcodeDataUI");

    if (printBarcodeDataUI?.HtmlString) {
      setTimeout(() => {
        if (barcodeRef.current) {
          let barcodeSVG = barcodeRef.current.outerHTML;
          barcodeSVG = barcodeSVG
            .replace(/width="[\d.]+px"/, 'width="330px"')
            .replace(/height="[\d.]+px"/, 'height="130px"');
          let printContent = printBarcodeDataUI.HtmlString;

          const mrp = parseFloat(item.MRP) || 0;
          const avgPrice = parseFloat(item.AvgPrice) || 0;
          const discountPercent =
            mrp > 0 ? Math.round(((mrp - avgPrice) / mrp) * 100) : 0;
          const formattedDiscount = `${discountPercent}`;
          console.log(formattedDiscount);
          printContent = printContent
            .replace("#ORGNAME#", item.StoreName || "")
            .replace("#ITEMNAME#", item.ProductName || "")
            .replace("#MRPPRICE#", item.MRP)
            .replace("#ITEMPRICE#", item.MRP)
            .replace("#BARCODEIMG#", barcodeSVG)
            .replace("#STOREPRICE#", item.AvgPrice || "");

          const printWindow = window.open("", "_blank");
          printWindow.document.write(`
            <html>
              <head>
                <title>Print Barcode</title>
              </head>
              <body>${printContent}</body>
            </html>
          `);
          console.log(printContent);
          printWindow.document.close();

          setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          }, 500);
        } else {
          console.error("barcodeRef.current is undefined");
        }
      }, 0);
    } else {
      setTimeout(() => {
        if (barcodeRef.current) {
          const barcodeSVG = barcodeRef.current.outerHTML;

          const mrp = parseFloat(item.MRP) || 0;
          const avgPrice = parseFloat(item.AvgPrice) || 0;
          const discountPercent =
            mrp > 0 ? Math.round(((mrp - avgPrice) / mrp) * 100) : 0;
          const formattedDiscount = `${discountPercent}`;
          console.log(item.StoreName);
          const printContent = `
         <table border="0" width="100%" style="border-collapse: collapse; font-family: Arial, sans-serif;">
  <tr>
    <td colspan="2" style="font-weight:bold; font-size:20px;" align="center">
      <b>${item.StoreName || ""}</b>
    </td>
  </tr>

  <tr class="service">
    <td colspan="2" align="center" >
      <div style='width:350px; height:auto;'>${barcodeSVG}</div>
    </td>
  </tr>

  <tr>
    <td colspan="2" align="center" style="font-size:20px;">
      <b>${item.ProductName || ""}</b>
    </td>
  </tr>

  <!-- Labels -->
  <tr>
    <td style="font-size:20px; padding:0; text-align:right;padding-right:1rem;  width:50%;">
      MRP:-   <b style='font-size:32px;font-family:Arial;'>${item.MRP}/-</b>
    </td>
    <td style="display: flex; align-items: center; justify-content: flex-start;font-size:20px; padding:0; text-align:left; width:50%;gap: 0.5rem;">
    DISCOUNT:-<b style='font-size:32px;font-family:Arial;'>${formattedDiscount}%</b>
    </td>
  </tr>
</table>

        `;
          console.log(printContent);
          const printWindow = window.open("", "_blank");
          printWindow.document.write(`
          <html>
            <head>
              <title>Print Barcode</title>
              <style>
                body { font-family: Arial, sans-serif; padding: 20px; }
              </style>
            </head>
            <body>${printContent}</body>
          </html>
        `);
          printWindow.document.close();

          setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          }, 500);
        } else {
          console.error("barcodeRef.current is undefined");
        }
      }, 0);
    }
  };
  useEffect(() => {
    if (
      printBarcodeData &&
      printBarcodeDataUI?.HtmlString &&
      barcodeRef.current
    ) {
      const mrp = parseFloat(printBarcodeData.MRP) || 0;
      const avgPrice = parseFloat(printBarcodeData.AvgPrice) || 0;
      const discountPercent =
        mrp > 0 ? Math.round(((mrp - avgPrice) / mrp) * 100) : 0;
      const formattedDiscount = `${discountPercent}`;
      console.log(formattedDiscount);
      const barcodeSVG = barcodeRef.current.outerHTML;
      const overrideStyle = `
    <style>
      #print-section {
        min-height: 0 !important;
        padding-top: 3px !important;
      }
    </style>
  `;

      const parsedHtml = printBarcodeDataUI.HtmlString.replace(
        "#ORGNAME#",
        printBarcodeData.StoreName || "",
      )
        .replace("#ITEMNAME#", printBarcodeData.ProductName || "")
        .replace("#MRPPRICE#", printBarcodeData.MRP)
        .replace("#ITEMPRICE#", printBarcodeData.MRP)
        .replace("#BARCODEIMG#", barcodeSVG)
        .replace("#STOREPRICE#", printBarcodeData.AvgPrice || "");

      setParsedHtmlPreview(overrideStyle + parsedHtml);
    }
  }, [printBarcodeData, printBarcodeDataUI, barcodeRef.current]);

  // console.log(printBarcodeData, "printBarcodeData printBeData");

  const handleGenerateQRCode = async (item) => {
    console.log(item);
    setPrintQRcodeData(item);
    try {
      const url = await QRCode.toDataURL(item.BarCode || "Default Text");
      qrCodeRef.current = url;
    } catch (error) {
      console.error("Error generating QR code:", error);
    }
  };

  const handlePrintQRcode = (item) => {
    setPrintQRcodeData(item);

    setTimeout(() => {
      if (qrCodeRef.current) {
        // Retrieve QR Code Image from reference
        // const qrCodeImg = `<img src="${qrCodeRef.current}" alt="QR Code" style="width: 220px; height: 220px; object-fit: contain;" />`;

        // Format Date
        const formatDate = (isoDate) => {
          const date = new Date(isoDate);
          return date.toLocaleDateString("en-GB");
        };

        // Replace placeholders in the HTML content
        let printContent = printBarcodeDataUI.QRCodestring;
        printContent = printContent
          .replace("$StoreName", item.StoreName)
          .replace("$ProductName", item.ProductName)
          .replace("$Weight", item.Weight)
          .replace("$MfgDate", formatDate(item.MfgDate))
          .replace("$ExpiryDate", formatDate(item.ExpiryDate))
          .replace("$MRP", item.MRP)
          .replace("$qrCode", qrCodeRef.current);
        console.log(printContent);

        // Open a new window and write the print content
        const printWindow = window.open("", "_blank");
        printWindow.document.write(printContent);
        printWindow.document.close();

        // Print and close the window
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        }, 500);
      } else {
        console.error("qrCodeRef.current is undefined");
      }
    }, 0);
  };

  const handleDeleteConfirmation = async (record) => {
    const result = await MySwal.fire({
      title: "Are you sure you want to delete this product?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await Axios.post(`${API_BASE_URL}Product/DelProduct`, {
        Id: record.Id,
        OrgId: userDataSession?.OrgId,
        UserId: userDataSession?.UserId,
      });

      if (response.data.ResultData[0].Status === "Success") {
        await MySwal.fire({
          title: "Deleted!",
          text: "Product has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
        });
        fetchPaginatedProducts(currentPage, pageSize); // Refetch current page
      } else {
        await MySwal.fire("Error", "Failed to delete the Product.", "error");
      }
    } catch (error) {
      await MySwal.fire("Error", "An error occurred while deleting.", "error");
    }
  };

  const handleDownloadExcel = async () => {
    if (totalRecords === 0) {
      alert("No data to export");
      return;
    }

    const fullData = await fetchPaginatedProducts(1, totalRecords, true);
    if (!fullData || fullData.length === 0) return;

    const wsData = fullData.map((item) => ({
      "Product Name": item.ProductName,
      BarCode: item.BarCode,
      Category: item.CategoryName,
      "All Stock": item.AllStock,
      MRP: item.MRP,
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "ProductsData");
    XLSX.writeFile(wb, "ProductsData.xlsx");
  };

  const generatePDF = async () => {
    if (totalRecords === 0) {
      alert("No data to export");
      return;
    }

    const fullData = await fetchPaginatedProducts(1, totalRecords, true);
    if (!fullData || fullData.length === 0) return;

    const doc = new jsPDF();
    doc.setProperties({
      title: "Product List",
      author: "Your Name",
      creator: "IBIZ",
    });

    const tableData = fullData.map((item) => [
      item.ProductName || "",
      item.BarCode || "",
      item.CategoryName || "",
      item.MRP || 0,
      item.AllStock || "",
    ]);

    doc.autoTable({
      head: [["Name", "BarCode", "Category", "MRP", "All Stock"]],
      body: tableData,
    });

    doc.save("ProductsData.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Product List</h4>
              <h6>Manage your products</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li className={`${permissions.isExport}`}>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link onClick={generatePDF}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li className={`${permissions.isExport}`}>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={handleDownloadExcel}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li onClick={handleReload}>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link
              to={route.addproduct}
              className={`btn btn-added ${permissions.isRead}`}
            >
              <PlusCircle className="iconsiz fs-2" />
            </Link>
          </div>
          <div className="page-btn import">
            <Link
              to="#"
              className={`btn btn-added color ${permissions.isRead}`}
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
            >
              <Download className="me-2" />
              Import Product
            </Link>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              {!isFilterVisible && (
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search by Product Name"
                      className="form-control form-control-sm formsearch"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>

                  {/* Show Search Button only when Advanced Filter is CLOSED */}

                  <Link
                    to="#"
                    className={`btn btn-searchset btn-primary `}
                    //  className={`btn btn-searchset btn-primary ${isFilterVisible? "d-none":""}` }
                    onClick={handleSearchClick}
                  >
                    <i data-feather="search" className="feather-search" />{" "}
                    Search
                  </Link>
                </div>
              )}

              <div className="search-path">
                <Link
                  className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`}
                  id="filter_search"
                  onClick={toggleFilterVisibility}
                >
                  <Filter className="filter-icon" />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
            </div>

            {/* Advanced Filters */}
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row mb-2">
                  <div className="col-lg-12 col-sm-12">
                    <div className="row">
                      {/* Your Store, Category, Product, Barcode fields here */}

                      <div className="col-lg-2 col-sm-6 col-12">
                        <label>Search</label>
                        <input
                          type="text"
                          placeholder="Search by Product Name"
                          className="form-control"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        <label>Store</label>
                        <Select
                          className="select"
                          onChange={handleStoreChange}
                          options={storeOptions}
                          placeholder="Choose store"
                          isLoading={isStoreLoading}
                        />
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        <label>Category</label>
                        <Select
                          className="select"
                          value={selectedCategory}
                          onChange={handleCategoryChange}
                          options={categoryOptions}
                          placeholder="Choose Category"
                          isLoading={isCategoryLoading}
                        />
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        <label>Product</label>
                        <Select
                          className="select"
                          onChange={handleProductChange}
                          options={productOptions}
                          placeholder="Choose product"
                          isLoading={isProductLoading}
                        />
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        <label>Barcode</label>
                        <input
                          className="form-control"
                          id="barcodeInput"
                          placeholder="Barcode"
                        />
                      </div>

                      <div className="col-lg-2 col-sm-6 col-12 d-flex align-items-end">
                        <button
                          onClick={handleSearchClick}
                          className="btn btn-filters ms-auto btn-primary"
                        >
                          <i data-feather="search" className="feather-search" />{" "}
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="table-responsive">
              {!isOnline ? (
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={OnlineImg}
                    alt="offline-status"
                    className="mb-3"
                    style={{ height: "30rem" }}
                  />
                  <p>You are offline. Please check your internet connection.</p>
                </div>
              ) : loading ? (
                <SpinLoader />
              ) : (
                <PaginationDataTable
                  columns={columns}
                  dataSource={products}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  totalRecords={totalRecords}
                  onPageChange={handlePageChange}
                />
              )}
            </div>
          </div>
        </div>

        {/* Image Modal - Your original */}
        {isModalOpen && (
          <div
            className="modal show d-block"
            tabIndex="-1"
            onClick={handleCloseModal}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              backdropFilter: "blur(1px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1050,
            }}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Image Preview</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal}
                  ></button>
                </div>
                <div className="modal-body text-center">
                  <h5 className="text-primary mb-1">{selectedImageName}</h5>
                  <img
                    src={`${IMAGE_URL_IBIZ}${selectedImage}`}
                    alt="Large Preview"
                    className="rounded shadow"
                    style={{ width: "50%", maxWidth: "100%", height: "auto" }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Brand />
      <ProductExcels />
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewBarcode"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "40%", maxWidth: "40%" }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel" className="mb-0">
            Barcode Preview
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          {!printBarcodeData ? (
            <div className="text-center">No barcode data available</div>
          ) : parsedHtmlPreview && parsedHtmlPreview.trim() !== "" ? (
            <div className="m-auto col-12 text-center overflow-hidden">
              <div className="d-none d-block">
                <svg ref={barcodeRef} />
              </div>
              <div
                className="p-0 w-100"
                style={{ overflowX: "hidden", maxWidth: "100%" }}
                dangerouslySetInnerHTML={{ __html: parsedHtmlPreview }}
              />
              <div className="modal-footer-btn">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-success"
                  onClick={() => handlePrintBarcode(printBarcodeData)}
                >
                  Print
                </button>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="m-auto text-center col-6">
                <h5 className="text-uppercase">
                  {printBarcodeData?.StoreName}
                </h5>
                <h5 className="text-uppercase">
                  {printBarcodeData?.ProductName}
                </h5>
                <div className="col-12 m-auto">
                  <table className="table table-border">
                    <tbody>
                      <tr style={{ lineHeight: "0.5", padding: "0" }}>
                        <td className="text-start fw-semibold p-0 ">
                          Net.Weight:
                        </td>
                        <th className="text-end fw-bold p-0 ">
                          {printBarcodeData?.Weight}
                        </th>
                      </tr>
                      <tr style={{ lineHeight: "0.5", padding: "0" }}>
                        <td className="text-start fw-semibold p-0 ">
                          Packaged On:
                        </td>
                        <th className="text-end fw-bold p-0 ">
                          {new Date(
                            printBarcodeData?.MfgDate,
                          ).toLocaleDateString("en-GB")}
                        </th>
                      </tr>
                      <tr style={{ lineHeight: "0.5", padding: "0" }}>
                        <td className="text-start fw-semibold p-0 ">
                          Best Before:
                        </td>
                        <th className="text-end fw-bold p-0 ">
                          {new Date(
                            printBarcodeData?.ExpiryDate,
                          ).toLocaleDateString("en-GB")}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h5 className="">MRP - {printBarcodeData?.MRP}/-</h5>
                <svg
                  ref={barcodeRef}
                  className="col-12"
                  style={{ marginTop: "-14px" }}
                />
              </div>
              <div className="modal-footer-btn">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-success"
                  onClick={() => handlePrintBarcode(printBarcodeData)}
                >
                  Print
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* QRcode Preview */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewQRcode"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "40%", maxWidth: "40%" }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel" className="mb-0">
            QRcode Preview
          </h4>
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>
        <hr />
        <div className="offcanvas-body">
          <div className="row">
            <h5 className="text-uppercase text-center">
              {printQRcodeData?.StoreName}
            </h5>
            <h5 className="text-uppercase text-center">
              {printQRcodeData?.ProductName}
            </h5>
            <div className="justify-content-center d-flex">
              <div className="col-md-4 text-start">
                <table className="table table-borderless">
                  <tbody>
                    <tr style={{ lineHeight: "0.5" }}>
                      <td className="text-start fw-semibold p-0">
                        Net Weight:
                      </td>
                      <th className="text-end fw-bold p-0">
                        {printQRcodeData?.Weight}
                      </th>
                    </tr>
                    <tr style={{ lineHeight: "0.5" }}>
                      <td className="text-start fw-semibold p-0">
                        Packaged On:
                      </td>
                      <th className="text-end fw-bold p-0">
                        {new Date(printQRcodeData?.MfgDate).toLocaleDateString(
                          "en-GB",
                        )}
                      </th>
                    </tr>
                    <tr style={{ lineHeight: "0.5" }}>
                      <td className="text-start fw-semibold p-0">
                        Best Before:
                      </td>
                      <th className="text-end fw-bold p-0">
                        {new Date(
                          printQRcodeData?.ExpiryDate,
                        ).toLocaleDateString("en-GB")}
                      </th>
                    </tr>
                  </tbody>
                </table>
                <h5 className="mt-2">MRP - {printQRcodeData?.MRP}/-</h5>
              </div>

              <div className="col-md-3 text-center d-flex flex-column align-items-center justify-content-center">
                <img
                  src={qrCodeRef.current}
                  alt="Generated QR Code"
                  style={{ width: "100px", height: "100px" }}
                />
                <h6>{printQRcodeData?.BarCode}</h6>
              </div>
            </div>
          </div>

          <div className="modal-footer-btn mt-3 text-end">
            <button
              type="button"
              className="btn btn-cancel me-2"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-success"
              onClick={() => handlePrintQRcode(printQRcodeData)}
            >
              Print
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductList;
